// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
import { NavigateFunction, Location } from '@rocketlane/rocket-router';

class RlNavigation {
  navigate!: NavigateFunction;

  location!: Location;

  set(navigate: NavigateFunction, location: Location) {
    this.navigate = navigate;
    this.location = location;
  }

  async push(u: string) {
    if (this.navigate) {
      this.navigate(u);
    }
  }

  path() {
    if (this.location) {
      return this.location.pathname;
    }

    return '';
  }
}

export const rlNavigation = new RlNavigation();
